import React from 'react'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import DialogButton from "./DialogButton"


const OkDialogButton = (props) => {
    const { classes, children, className, ...other } = props
    return(
        <DialogButton 
            variant={props.variant || "contained"} 
            className={className}
            sx={{
                fontSize: "14px", 
                fontFamily: "Open Sans",
                backgroundColor: "#00c853",
                color: "white",
                minWidth: "90px",
                '&:hover': {
                    backgroundColor: "#008c3a"
                },
                "&:disabled": {
                    color: "white",
                    backgroundColor: "#81c784"
                }
            }}
            color={"success"}
            {...other}
        >
            {children || "OK"}
        </DialogButton>
    )
}

DialogButton.propTypes = {
    children: PropTypes.node,
}

export default OkDialogButton